export const CLASS_CREATE_ZOOM_PASSWORD_ERROR = 3018;
export const CLASS_CREATE_INSTRUCTOR_MISSING_ZOOM_CREDENTIALS = 3007;
